import { render, staticRenderFns } from "./SubjectOrdersComponent.vue?vue&type=template&id=6a0cb76a"
import script from "./SubjectOrdersComponent.vue?vue&type=script&lang=js"
export * from "./SubjectOrdersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports